import React, { useMemo } from "react";
import { MimaButton, MimaTable } from "../../components";
import constant from "../../utils/constant";
import moment from "moment";
import { downloadXlsx2 } from "../../utils/download";

const BusinessPartner = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  setItem,
  setTodoModal,
  setTradingName,
}) => {
  const businessPartnerTableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.commissions || [];
    }
    return [];
  }, [data]);

  const businessPartnerTableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY")}</span>;
      },
    },
    {
      Header: "Business Partner",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const tradingName = cell.row.original.businessPartner?.tradingName;
        return <span>{tradingName}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "business",
      Cell: ({ cell }) => {
        const business = cell.row.original?.business?.tradingName;
        return <span>{business}</span>;
      },
    },
    {
      Header: "Commission Status",
      accessor: "commissionStatus",
    },
    {
      Header: "Subscription Status",
      accessor: "subscriptionStatus",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original.business.id;
        const tradingName = cell.row.original?.business?.tradingName;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              setItem(item);
              setTradingName(tradingName);
              setTodoModal(true);
            }}
          >
            View Todo Info
          </span>
        );
      },
    },
  ];

  const printData = businessPartnerTableData.map((item) => ({
    "Created Date": item?.createdAt,
    "Business Partner": item.businessPartner?.tradingName || "",
    "Business Name": item.business?.tradingName || "",
    "Commissions Status": item.commissionStatus || "",
    "Subscription Status": item.subscriptionStatus || "",
  }));

  return (
    <>
      <MimaButton
        title="Download Partner Report"
        onClick={() => {
          downloadXlsx2(printData, "Partner Report");
        }}
        mt={4}
      />
      <MimaTable
        tableData={businessPartnerTableData}
        tableColumns={businessPartnerTableColumns}
        searchPlaceholder="Search News"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />
    </>
  );
};
export default BusinessPartner;
